export interface DrawingInactiveInputModel {

    groupId: number,
    projectId: number,
    doc_Id: string,
    doc_title: string,
    doc_no: string,
    status: boolean,
    userid?: number,
    disciplineId?: number | null

}
export interface DrawingInactiveOutputModel {

    document_no: string,
    document_title: string,
    doc_Id: number,
    is_select: boolean,

    document_type: string,
    response: string,
    created_By?: string,
    created_On?: string,
    modified_By?: string,
    modified_On?: string
}
export interface IDeleteDocumentInputModel {

    groupId: number,
    projectId: number,
    doc_Id: string,
    revision_type: string,
    UserId: number

}
export interface IDeleteDocumentOutputModel {

    document_no: string,
    document_title: string,
    doc_Id: number,
    latest_revision_no: string,
    is_select: boolean,
    document_type: string,
    isTransmittalAvailable: boolean,
    isComminicationAvailable: boolean,
    is_Active: boolean,
    revSlNo: number,
}